import { useEffect, useState } from "react";
import fetchData from "../../shared/fetchData";
import ContentForm from "../UI/ContentForm/ContentForm";
import SelectBox from "../UI/Select/Select";
import Button from "../UI/Button/Button";
import { Grid } from "@material-ui/core";
import Spinner from "../UI/Spinner/Spinner";
import { toast } from "react-toastify";

const CopyUnitKioskForm = (props) => {
  const [fromUnit, setFromUnit] = useState("");
  const [toUnit, setToUnit] = useState("");
  const [units, setUnits] = useState([]);
  const [invalidSelect, setInvalidSelect] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    var raw = JSON.stringify({
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/units/getUnits";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setUnits(result.units);
      });
  }, []);

  const fromUnitChange = (formatted) => {
    setFromUnit(formatted);
  };

  const toUnitChange = (formatted) => {
    setToUnit(formatted);
  };

  const copyUnitKiosk = () => {
    let valid = true;
    if (fromUnit == "" || fromUnit == null) {
      setInvalidSelect(true);
      valid = false;
    }
    if (toUnit == "" || toUnit == null) {
      setInvalidSelect(true);
      valid = false;
    }
    if (valid) {
      var raw = JSON.stringify({
        fromUnitId: !!fromUnit && fromUnit != "" ? fromUnit.value : "",
        toUnitId: !!toUnit && toUnit != "" ? toUnit.value : "",
        version: "mtpx001",
      });
      var url = "management/api/v1/unitkiosks/copyUnitKiosk";
      setLoading(true);
      fetchData(raw, url)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0") {
            toast.success("عملیات با موفقیت انجام شد");
            props.back();
          }
        });
    }
  };

  let unitList = [];
  if (units != null && units.length != 0) {
    units.map((k) => {
      unitList.push({
        value: k.id,
        label: k.unitName,
      });
    });
  }
  return (
    <>
      {loading && <Spinner />}
      <ContentForm headetText="صورتحساب">
        <SelectBox
          name="form-field-name"
          value={fromUnit}
          placeholder="از حساب"
          options={unitList}
          onChange={fromUnitChange}
          col="12"
          className={
            invalidSelect && (fromUnit == null || fromUnit == "")
              ? "invalid-select"
              : ""
          }
        />
        <SelectBox
          name="form-field-name"
          value={toUnit}
          placeholder="به حساب"
          options={unitList}
          onChange={toUnitChange}
          col="12"
          className={
            invalidSelect && (toUnit == null || toUnit == "")
              ? "invalid-select"
              : ""
          }
        />
        <div className="row justify-content-center mt-3 w-100">
          <Grid lg={4} xs={5} className="text-center">
            <Button
              btnType="General"
              clicked={() => {
                props.back();
              }}
            >
              برگشت
            </Button>
          </Grid>
          <Grid lg={4} xs={5} className="text-center">
            <Button btnType="Success" clicked={copyUnitKiosk}>
              ثبت
            </Button>
          </Grid>
        </div>
      </ContentForm>
    </>
  );
};
export default CopyUnitKioskForm;
